import React from "react";
import Testimonials from "../home/Testimonials";

const FeaturesTestimonials = () => {
  return <Testimonials />;
};

export default FeaturesTestimonials;
